import { graphql } from "gatsby"
import type { SquidexMarkdownEmbeddedContent } from "~/types/squidex"

export type SquidexTableWithContentRow = {
  label: string
  values: {
    type: string
    text?: string | SquidexMarkdownEmbeddedContent
    isAvailable?: boolean
  }[]
}

export enum SquidexTableWithContentCellType {
  TEXT = "tekst",
  DEFAULT_ICONS = "znacznik wyboru",
}

export const query = graphql`
  fragment TableWithContentRow on GraphCmsSquidex_TableWithContentRowComponent {
    label
    values {
      type
      text {
        text
        contents {
          ... on GraphCmsSquidex_StaticPrice {
            ...StaticPrice
          }
          ... on GraphCmsSquidex_MarketplaceSaleConfiguration {
            ...SaleConfigurations
          }
          ... on GraphCmsSquidex_CloudblueDomain {
            ...CloudBlueDomain
          }
          ... on GraphCmsSquidex_PriceTypeContextText {
            ...PriceTypeContextText
          }
          ... on GraphCmsSquidex_Tooltip {
            ...Tooltip
          }
        }
      }
      isAvailable
    }
  }
`

export const FRAGMENT_TABLE_WITH_CONTENT_ROW = `
  fragment TableWithContentRow on TableWithContentRowComponent {
    label
    values {
      type
      text {
        text
        contents {
          ... on StaticPrice {
            ...StaticPrice
          }
          ... on MarketplaceSaleConfiguration {
            ...SaleConfigurations
          }
          ... on CloudblueDomain {
            ...CloudBlueDomain
          }
          ... on PriceTypeContextText {
            ...PriceTypeContextText
          }
          ... on Tooltip {
            ...Tooltip
          }
        }
      }
      isAvailable
    }
  }
`
